import { createStore } from "redux";
import { blip } from "./reducers";

const store = createStore(blip);

export default store;
